/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { AccessOutcome, AccessOutcomeFromJSON, AccessOutcomeFromJSONTyped, AccessOutcomeToJSON } from "./";

/**
 *
 * @export
 * @interface ClientAccessBootstrap
 */
export interface ClientAccessBootstrap {
  /**
   *
   * @type {Array<string>}
   * @memberof ClientAccessBootstrap
   */
  clients?: Array<string> | null;
  /**
   *
   * @type {AccessOutcome}
   * @memberof ClientAccessBootstrap
   */
  accessOutcome?: AccessOutcome;
  /**
   *
   * @type {string}
   * @memberof ClientAccessBootstrap
   */
  brandDisplayName?: string | null;
}

export function ClientAccessBootstrapFromJSON(json: any): ClientAccessBootstrap {
  return ClientAccessBootstrapFromJSONTyped(json, false);
}

export function ClientAccessBootstrapFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientAccessBootstrap {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    clients: !exists(json, "clients") ? undefined : json["clients"],
    accessOutcome: !exists(json, "accessOutcome") ? undefined : AccessOutcomeFromJSON(json["accessOutcome"]),
    brandDisplayName: !exists(json, "brandDisplayName") ? undefined : json["brandDisplayName"],
  };
}

export function ClientAccessBootstrapToJSON(value?: ClientAccessBootstrap | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    clients: value.clients,
    accessOutcome: AccessOutcomeToJSON(value.accessOutcome),
    brandDisplayName: value.brandDisplayName,
  };
}
